export interface SingleDatePickerValue {
  date: Date;
  hasTime: boolean;
}
